import {Contenitore} from './Contenitore';
import {Ordine} from './Ordine';
import {OrdineEsolver} from './OrdineEsolver';
import {StatoEnum} from './generated/stato-enum';
import {DettaglioPercorso} from './AccountOrganizzazione';

// Feature 162 «Info contenitore»: specchio di ContenitoreInfo/FaseInfo della LocalApi.
export enum RamoProssimaFase {
  Nessuno = 0,
  StessaRiga = 1,
  Distinta = 2
}

export interface FaseInfo {
  idDocumento: number;
  idRiga: number;
  idRigaLavorazione: number;
  numFase: number;
  rifOdP?: string;
  numRegistrazione?: number;
  codiceArticolo?: string;
  descArticolo?: string;
  codiceRisorsa?: string;
  codiceLavorazione?: string;
  // Feature 166: descrizioni (la locale prevale) e posizione nel percorso.
  descRisorsa?: string;
  descLavorazione?: string;
  posizione?: PosizionePercorso;
  stato?: StatoEnum;
  flgTerminato: boolean;
  giaLanciata: boolean;
  puoAprire: boolean;
  motivo?: string;
  ordine?: Ordine;
  ordineEsolver?: OrdineEsolver;
  fasiPrecedentiAperte: number;
}

export interface ContenitoreInfo {
  contenitore?: Contenitore;
  figli: Contenitore[];
  daProduzione: boolean;
  fasiRiga: Ordine[];
  // Riga usata per le fasi: diversa da contenitore.rifOdP se il contenitore è stato consumato in parte altrove.
  rifOdPRiga?: string;
  faseAttuale?: FaseInfo;
  faseDeterminata: boolean;
  // Feature 163: fase letta da rifOdP + numFase del contenitore, senza cercare negli eventi.
  faseDaContenitore?: boolean;
  prossimeFasi: FaseInfo[];
  ramo: RamoProssimaFase;
  distintaNonSupportata: boolean;
  // Feature 166: assenti con una LocalApi precedente.
  dettaglio?: DettaglioPercorso;
  percorso?: PercorsoRiga[];
  // La riga del RifOdP consuma il contenitore: l'attuale è una fase di consumo.
  attualeInConsumo?: boolean;
  // Ordine completo senza le fasi del gestionale (errore o SPRING).
  percorsoParziale?: boolean;
}

/** Feature 166: posizione di una fase nel percorso del contenitore (stessi valori della LocalApi). */
export enum PosizionePercorso {
  DaFare = 0,
  Passata = 1,
  Attuale = 2,
  Alternativa = 3,
  Prossima = 4,
  FuoriPercorso = 5
}

export enum RuoloRiga {
  Contenitore = 0,
  Valle = 1,
  Altra = 2
}

export interface PercorsoRiga {
  idDocumento: number;
  idRiga: number;
  rifOdP?: string;
  numRegistrazione?: number;
  codiceArticolo?: string;
  descArticolo?: string;
  ruolo: RuoloRiga;
  // Valle: fase che consuma l'articolo della riga precedente del percorso.
  numFaseConsumo?: number;
  ultimaDelPercorso: boolean;
  fasi: FaseInfo[];
}
